<template>
  <div class="login-container">
    <login :service="false">店铺登录</login>
    <div class="wty-dialog" v-show="dialog_show">
      <div v-if="list_show">
        <div class="wty-dialog-title" style="">
          登录成功，请选择管理的店铺账号
        </div>
        <div class="wty-dialog-body">
          <div style="margin-bottom:10px;">您可以登录的后台有：</div>
          <el-scrollbar wrapStyle="overflow-x:hidden;" style="height: 460px;">
            <!-- background-color: rgb(77, 255, 0); -->
            <div style="">
              <div class="body-main">
                <div @click="checkedService(item)" class="" v-for="(item, index) in merchant_list" :key="index" :class="merchant_id == item.merchant_id
                  ? 'body-main-item-checked'
                  : 'body-main-item'
                  ">
                  <div class="item-label">{{ item.merchant_id }}：</div>
                  <div class="item-value">{{ item.merchant_name }}</div>
                </div>
              </div>
            </div>
          </el-scrollbar>
          <div class="wty-dialog-footer">
            <div class="footer-item" @click="showDialog(false)">取消</div>
            <div class="footer-item" @click="dialogSureClick">确定</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="wty-dialog-title" style="">
          {{ title }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import login from "../components/login.vue";
import { mapMutations } from "vuex";
import { mAccountListMerchant } from "@/api/merchant.js";
import { accountQuery } from "@/api/login.js";
export default {
  components: { login },
  provide() {
    return {
      showDialog: this.showDialog
    };
  },
  data() {
    return {
      title: "",
      list_show: true,
      dialog_show: false,
      merchant_id: "",
      merchant_name: "",
      merchant_list: []
    };
  },
  async created() { },
  beforeMount() { },
  async mounted() { },
  beforeDestroy() { },
  methods: {
    ...mapMutations("home", ["UPDATEMENUTABS"]),
    async dialogSureClick() {
      localStorage.setItem("merchant_id", this.merchant_id);
      localStorage.setItem("merchant_name", this.merchant_name);
      const res = await accountQuery();
      if (res.account_id) {
        localStorage.setItem("account_id", res.account_id);
      }
      this.UPDATEMENUTABS("/welcome");
      this.$router.push("/welcome");
      this.successMessage("店铺系统登录成功！！！");
    },
    async showDialog(key) {
      if (key) {
        const res = await mAccountListMerchant();
        if (res.length > 0) {
          this.merchant_list = res;
          this.merchant_list = [];
          for (let i = 0; i < res.length; i++) {
            this.merchant_list.push({
              merchant_id: res[i].merchant_id,
              merchant_name: res[i].sub_name
            });
          }
          if (this.merchant_list.length === 1) {
            this.merchant_id = this.merchant_list[0].merchant_id;
            this.merchant_name = this.merchant_list[0].merchant_name;
            this.dialogSureClick();
          }
          this.dialog_show = true;
        } else {
          this.warnMessage("未发现可登录的店铺后台");
        }
      } else {
        this.dialog_show = false;
      }
    },
    checkedService(value) {
      if (value.merchant_id === this.merchant_id) {
        this.merchant_id = "";
        this.merchant_name = "";
        return;
      }
      this.merchant_id = value.merchant_id;
      this.merchant_name = value.merchant_name;
    },
    optionShow() { },
    getGroupPermission() { }
  }
};
</script>
<style lang="less" scoped>
.login-container {
  background-color: #2b4b6b;
  background: url(../assets/pic/0001.jpg);
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: 105% auto;
  height: 100%;
}

.wty-dialog {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: rgba(1, 1, 1, 0.9);
  z-index: 2003;
  display: flex;

  .wty-dialog-title {
    position: fixed;
    top: 50px;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    font-weight: 700;
    font-size: 40px;
    color: #fff;
    text-align: center;
    z-index: 2004;
  }

  .wty-dialog-body {
    position: fixed;
    width: 800px;
    height: 550px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background-color: rgba(255, 255, 255, 0.8);
    z-index: 2004;
    font-size: 24px;
    // font-weight: 700;
    color: #fff;

    .body-main {
      width: 100%;
      padding: 0 20px;

      .body-main-item {
        height: auto;
        padding: 20px;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.4);
        margin: 10px 0;
        display: flex;
        color: #409eff;

        .item-label {
          width: 200px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow-x: hidden;
        }

        .item-value {
          width: 500px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow-x: hidden;
        }

        &:hover {
          background-color: rgba(0, 0, 0, 0.5);
          font-weight: 700;
          color: #fff;
        }
      }

      /* .body-main-item:hover {
        background-color: rgba(0, 0, 0, 0.5);
        font-weight: 700;
        color: #fff;
      } */
      .body-main-item-checked {
        background: #409eff;
        font-weight: 700;
        color: #fff;
        height: auto;
        padding: 20px;
        cursor: pointer;
        margin: 10px 0;
        display: flex;

        //TODO: 这里报错了
        .item-label {
          width: 200px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow-x: hidden;
        }

        .item-value {
          width: 500px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow-x: hidden;
        }
      }

      /* .item-label();
        .item-value(); */
      // height: 60px;
    }
  }

  .wty-dialog-footer {
    display: flex;
    justify-content: center;
    width: 100%;
    text-align: center;
    margin-top: 10px;

    .footer-item {
      width: auto;
      font-size: 30px;
      padding: 0 40px;
      cursor: pointer;
      font-weight: 700;
    }

    .footer-item:hover {
      color: #0280ff;
    }
  }
}
</style>
